/**
 * aswbe search eapi（ShoppingShopping）
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HistoryPostRequestHistoryBoundsInner } from './historyPostRequestHistoryBoundsInner';
import { Type9 } from './type9';
import { HistoryPostRequestHistoryRoundtrip } from './historyPostRequestHistoryRoundtrip';
import { NumberOfTravelers } from './numberOfTravelers';

/**
 * お気に入り検索条件 ※当項目とその配下の項目は、以下APIで共通で使用する。API毎に取り扱いに差異がある場合は、項目毎にコメントを記す。   ・履歴登録APIのリクエスト   ・お気に入り登録APIのリクエスト   ・お気に入り・履歴取得APIのレスポンス(履歴情報/お気に入り情報それぞれのレスポンス)
 */
export interface FavoritePostRequestFavorite {
  /**
   * プロモーションコード
   */
  promotionCode?: string;
  /**
   * 旅程タイプ   roundtrip：往復旅程   onewayOrMulticity：片道または複雑旅程
   */
  tripType: FavoritePostRequestFavorite.TripTypeEnum;
  roundtrip?: HistoryPostRequestHistoryRoundtrip;
  fare?: Type9;
  /**
   * データ登録時の日時（yyyy-MM-ddTHH:mm:ss）   ※GMT   ※履歴登録API/お気に入り登録APIのリクエストとして使用された場合、この項目は設定しない
   */
  creationDateTime?: string;
  /**
   * 片道または複雑旅程旅程バウンドリスト。   検索条件の区間数分のサイズとなる。   ※tripTypeがonewayOrMulticityの場合に設定する
   */
  bounds?: Array<HistoryPostRequestHistoryBoundsInner>;
  travelers?: NumberOfTravelers;
  /**
   * 別予約同行者有無   　true: 大人が別予約で同行する   　false: 大人が別予約で同行しない   ※搭乗者がCHD(小児)のみとなる場合は設定必須
   */
  hasAccompaniedInAnotherReservation?: boolean;
}
export namespace FavoritePostRequestFavorite {
  export type TripTypeEnum = 'roundtrip' | 'onewayOrMulticity';
  export const TripTypeEnum = {
    Roundtrip: 'roundtrip' as TripTypeEnum,
    OnewayOrMulticity: 'onewayOrMulticity' as TripTypeEnum,
  };
}
